import React, { useCallback } from 'react';
import { useHistory } from 'react-router';
import { SvgIcon } from 'src/components/common';
import { Button } from 'zarm';
import { validate } from 'src/utils';
import './emptycover.scss';

interface EmptyProps {
  config: {
    text: string;
    icon: string;
  };
  type: 'text' | 'goods' | 'search' | 'couponsearch' | 'conversion' | 'depositRecord' | 'couponReferral';
}

const EmptyCover = (props: EmptyProps) => {
  const history = useHistory();
  const {
    config: { text, icon },
    type,
  } = props;

  const prefixCls = 'empty-component';

  const goTo = useCallback(() => {
    if (validate.isFromOwnMiniApplet()) {
      return wx.miniProgram.switchTab({
        url: '/pages/home/index',
      });
    }
    history.replace('/');
  }, []);

  if (type === 'goods') {
    return (
      <div className={`${prefixCls} ${prefixCls}__${type}`}>
        <SvgIcon type="img" src={icon} />
        <p className="text">{text}</p>
      </div>
    );
  }
  if (type === 'search') {
    return (
      <div className={`${prefixCls} ${prefixCls}__${type}`}>
        <SvgIcon type="img" src={icon} />
        <p className="text">{text}</p>
      </div>
    );
  }
  if (type === 'couponsearch') {
    return (
      <div className={`${prefixCls} ${prefixCls}__${type}`}>
        <SvgIcon type="img" src={icon} />
        <p className="text1">{text}</p>
        <Button theme="primary" ghost size="sm" className="gohome" onClick={() => goTo()} shape="round">逛逛首页</Button>
      </div>
    );
  }
  if (type === 'conversion') {
    return (
      <div className="conversion">
        <SvgIcon type="img" className="conversionIcon" src={icon} />
      </div>
    );
  }
  if (type === 'couponReferral') {
    return (
      <div className={`${prefixCls} ${prefixCls}__${type}`}>
        <SvgIcon type="img" src={icon} />
        <p className="text1">{text}</p>
        <Button theme="primary" size="sm" className="goshoppingmall" onClick={() => goTo()} shape="round">去商城逛逛</Button>
      </div>
    );
  }
  return (
    <div className={prefixCls}>
      <SvgIcon type="img" src={icon} />
      <p className="text">{text}</p>
    </div>
  );
};

export default EmptyCover;
